import React, { useState, useEffect } from "react";
import Button from "@material-ui/core/Button";
import { useStateValue } from "../Stateprovider";
import { useHistory } from "react-router-dom";

import axios from "../axios";

import { Container, Card } from "react-bootstrap";

import { CardElement, useStripe, useElements } from "@stripe/react-stripe-js";

import { db } from "../firebase";

function loadScript(src) {
  return new Promise((resolve) => {
    const script = document.createElement("script");
    script.src = src;
    script.onload = () => {
      resolve(true);
    };
    script.onerror = () => {
      resolve(false);
    };
    document.body.appendChild(script);
  });
}

function Subtotal() {
  const [{ basket, user }, dispatch] = useStateValue();
  const history = useHistory();

  const [processing, setProcessing] = useState(false);
  const [succeeded, setSucceeded] = useState("");
  const [error, setError] = useState(null);
  const [disabled, setDisabled] = useState(true);
  const [clientSecret, setClientSecret] = useState(true);

  const stripe = useStripe();
  const elements = useElements();

  const handleChange = (e) => {
    // Process change
    setDisabled(e.empty);
    setError(e.error ? e.error.message : "");
  };

  const handlePayment = async (e) => {
    // Payment processing
    e.preventDefault();
    setProcessing(true);

    const payload = await stripe
      .confirmCardPayment(clientSecret, {
        payment_method: {
          card: elements.getElement(CardElement),
        },
      })
      .then(({ paymentIntent }) => {
        // its payment confirmation
        setSucceeded(true);
        setError(null);
        setProcessing(false);

        dispatch({
          type: "EMPTY_BASKET",
        });

        history.replace("/myprojects");
      });
  };

  console.log(basket);
  var total = 0;
  for (var item in basket) {
    console.log(basket[item]["price"]);
    total += basket[item]["price"];
  }

  basket.map((product) => {
    console.log(product.title);
  });

  const displayRazorpay = async () => {
    const res = await loadScript(
      "https://checkout.razorpay.com/v1/checkout.js"
    );
    if (!res) {
      alert("Rzp failed to load");
      return;
    }
    console.log(total * 100);
    const response = await axios({
      method: "POST",
      url: `/payments/razorpay?total=${total * 100}`,
    });
    console.log(response);

    const options = {
      key: "rzp_test_fJhNCBwhj72Typ", // Enter the Key ID generated from the Dashboard
      amount: response.data.amount, // Amount is in currency subunits. Default currency is INR. Hence, 50000 refers to 50000 paise
      currency: response.data.currency,
      name: "Cubes",
      description: "Test Transaction",
      image: "https://example.com/your_logo",
      order_id: response.data.id, //This is a sample Order ID. Pass the `id` obtained in the response of Step 1
      handler: function (r) {
        alert("Payment Successful!");
        db.collection("users")
          .doc(user?.uid)
          .collection("orders")
          .doc(response.data.id)
          .set({
            basket: basket,
            amount: response.data.amount,
            order_id: response.data.id,
            currency: response.data.currency,
          });
        basket.map((product) => {
          // add items to add in projects.
          db.collection("users")
            .doc(user?.uid)
            .collection("projects")
            .doc()
            .set({
              title: product.title,
              imageLink: product.image,
              description: product.description,
              id: product.id,
              language: product.language,
              level: product.level,
            });
        });

        // Make API request to create data!
        dispatch({
          type: "EMPTY_BASKET",
        });
      },

      notes: {
        address: "Razorpay Corporate Office",
      },
      theme: {
        color: "#3399cc",
      },
    };
    var paymentObject = new window.Razorpay(options);
    paymentObject.open();
  };

  useEffect(() => {
    // Generate customer secret.

    const getClientSecret = async () => {
      const response = await axios({
        method: "POST",
        url: `/payments/create?total=${total * 100}`,
      });
      setClientSecret(response.data.clientSecret);
    };

    getClientSecret();
  }, [basket]);

  console.log("Secret is ", clientSecret);

  return (
    <div>
      <p>
        <Card className="pl-3 pr-3 pt-2 pb-4">
          Total Cost: <strong>${total}</strong>
          <br></br>
          <Button
            // disabled={processing || disabled || succeeded}
            variant="contained"
            color="primary"
            onClick={displayRazorpay}
          >
            {processing ? "Processing" : "Proceed to payment"}
          </Button>
        </Card>
      </p>
    </div>
  );
}

export default Subtotal;
